import React from 'react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
import { CTAButton } from './CTAButton';
export function EbookSection() {
  return <section className="border-t border-white/5 bg-void-950 py-24 md:py-32" data-id="element-35" data-mp="31n06zujrlw59">
      <div className="mx-auto grid max-w-6xl gap-14 px-6 lg:grid-cols-2 lg:gap-20" data-id="element-36" data-mp="36l1ls3a5r9ax">
        <Reveal className="lg:sticky lg:top-24 lg:self-start" data-id="element-37" data-mp="3biurywbgo3b7">
          <div className="relative" data-id="element-38" data-mp="2dw4gd0r1p6zl">
            <div className="absolute -inset-8 rounded-full bg-gold-500/15 blur-3xl" aria-hidden="true" data-id="element-39" data-mp="2dx5uxf79sbm2" />
            <img src="https://cdn.magicpatterns.com/uploads/4UTN9roSJtn2EekvHrqQ5Z/tapa.png" alt="eBook ¿Estás listo para jugar? sobre fondo oscuro" className="relative mx-auto w-full max-w-sm rounded-sm shadow-neon-lg ring-1 ring-gold-500/30" data-id="element-40" data-mp="2nu24lo8wn3s7" />
          </div>
        </Reveal>

        <div data-id="element-41" data-mp="2036504y7j4ae">
          <Reveal data-id="element-42" data-mp="202wmt3jem1f9">
            <SectionLabel data-id="element-43" data-mp="2023evz8pl5vj">El eBook</SectionLabel>
            <h2 className="font-display text-3xl font-light leading-tight text-bone-50 sm:text-4xl md:text-[2.75rem]" data-id="element-44" data-mp="159stm7j5whza">
              ¿Estás listo para jugar?{' '}
              <span className="neon-text block text-gold-400" data-id="element-45" data-mp="10csobyu4zj98">
                Una guía para ver lo que siempre estuvo frente a ti.
              </span>
            </h2>
          </Reveal>

          <div className="mt-9 space-y-6 text-base leading-relaxed text-bone-300 sm:text-lg" data-id="element-46" data-mp="qik7i8egxeqw">
            <Reveal delay={0.05} data-id="element-47" data-mp="mgyoe5bcc489">
              <p data-id="element-48" data-mp="hk88pj3g7and">
                Este no es un libro común. Es una invitación a observar la realidad desde otro
                nivel: como si por primera vez pudieras detenerte, mirar el tablero completo y
                preguntarte qué partida estás jugando… y quién escribió las reglas.
              </p>
            </Reveal>
            <Reveal delay={0.1} data-id="element-49" data-mp="26xtw5hya1084">
              <p data-id="element-50" data-mp="26wsj57xpa3nr">
                Es una guía de reflexión escrita para hombres y mujeres que ya no se conforman
                con vivir en automático. Para quienes sienten que hay capas más profundas detrás
                de la rutina, del miedo y de la programación mental que reciben cada día.
              </p>
            </Reveal>
            <Reveal delay={0.15} data-id="element-51" data-mp="3micnshn1h665">
              <p data-id="element-52" data-mp="3mj5iulcmy78g">
                Si alguna vez te has preguntado por qué estás aquí, qué hay detrás del juego, o
                cómo recuperar tu poder interior… este eBook fue escrito para ti.
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.2} data-id="element-53" data-mp="o07551lm1ibh">
            <CTAButton label="Empezar el juego" className="mt-10" data-id="element-54" data-mp="nz5pskxka9ny" />
          </Reveal>
        </div>
      </div>
    </section>;
}